
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $ccce0a99ce9219de$exports = {};
$ccce0a99ce9219de$exports = JSON.parse("[{\"inputs\":[{\"internalType\":\"address\",\"name\":\"_profileContract\",\"type\":\"address\"}],\"stateMutability\":\"nonpayable\",\"type\":\"constructor\"},{\"inputs\":[{\"internalType\":\"uint16\",\"name\":\"newTweetLength\",\"type\":\"uint16\"}],\"name\":\"changeTweetLength\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"string\",\"name\":\"_tweet\",\"type\":\"string\"}],\"name\":\"createTweet\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"author\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"id\",\"type\":\"uint256\"}],\"name\":\"likeTweet\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"author\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"id\",\"type\":\"uint256\"}],\"name\":\"unlikeTweet\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"_owner\",\"type\":\"address\"}],\"name\":\"getAllTweets\",\"outputs\":[{\"components\":[{\"internalType\":\"uint256\",\"name\":\"id\",\"type\":\"uint256\"},{\"internalType\":\"address\",\"name\":\"author\",\"type\":\"address\"},{\"internalType\":\"string\",\"name\":\"content\",\"type\":\"string\"},{\"internalType\":\"uint256\",\"name\":\"timestamp\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"likes\",\"type\":\"uint256\"}],\"internalType\":\"struct Twitter.Tweet[]\",\"name\":\"\",\"type\":\"tuple[]\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"owner\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"index\",\"type\":\"uint256\"}],\"name\":\"getTweet\",\"outputs\":[{\"components\":[{\"internalType\":\"uint256\",\"name\":\"id\",\"type\":\"uint256\"},{\"internalType\":\"address\",\"name\":\"author\",\"type\":\"address\"},{\"internalType\":\"string\",\"name\":\"content\",\"type\":\"string\"},{\"internalType\":\"uint256\",\"name\":\"timestamp\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"likes\",\"type\":\"uint256\"}],\"internalType\":\"struct Twitter.Tweet\",\"name\":\"\",\"type\":\"tuple\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_i\",\"type\":\"uint256\"}],\"name\":\"getMyTweet\",\"outputs\":[{\"components\":[{\"internalType\":\"uint256\",\"name\":\"id\",\"type\":\"uint256\"},{\"internalType\":\"address\",\"name\":\"author\",\"type\":\"address\"},{\"internalType\":\"string\",\"name\":\"content\",\"type\":\"string\"},{\"internalType\":\"uint256\",\"name\":\"timestamp\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"likes\",\"type\":\"uint256\"}],\"internalType\":\"struct Twitter.Tweet\",\"name\":\"\",\"type\":\"tuple\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"author\",\"type\":\"address\"}],\"name\":\"getTotalLikes\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"MAX_TWEET_LENGTH\",\"outputs\":[{\"internalType\":\"uint16\",\"name\":\"\",\"type\":\"uint16\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"owner\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"profileContract\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"_profileContract\",\"type\":\"address\"}],\"name\":\"setProfileContract\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"}]");


const $35da740d59af89ba$var$contractAddress = "0x53799Fd6997ac709BDA34F02cA51953EC104B876";
let $35da740d59af89ba$var$web3 = new Web3(window.ethereum);
let $35da740d59af89ba$var$contract = new $35da740d59af89ba$var$web3.eth.Contract((0, (/*@__PURE__*/$parcel$interopDefault($ccce0a99ce9219de$exports))), $35da740d59af89ba$var$contractAddress);
async function $35da740d59af89ba$var$connectWallet() {
    if (!window.ethereum) {
        console.error("No web3 provider detected");
        document.getElementById("connectMessage").innerText = "No web3 provider detected. Please install MetaMask.";
        return;
    }
    const accounts = await window.ethereum.request({
        method: "eth_requestAccounts"
    }).catch((err)=>{
        if (err.code === 4001) console.log("Please connect to MetaMask.");
        else console.error(err);
    });
    if (!accounts || !accounts[0]) return;
    $35da740d59af89ba$var$setConnected(accounts[0]);
}
async function $35da740d59af89ba$var$createTweet(content) {
    const accounts = await $35da740d59af89ba$var$web3.eth.getAccounts();
    try {
        await $35da740d59af89ba$var$contract.methods.createTweet(content).send({
            from: accounts[0]
        });
        $35da740d59af89ba$var$displayTweets(accounts[0]);
    } catch (error) {
        console.error("Create tweet error:", error);
        // Check for registration problem and show helpful message
        try {
            const profileAddr = await $35da740d59af89ba$var$contract.methods.profileContract().call();
            document.getElementById("connectMessage").style.display = "block";
            document.getElementById("connectMessage").innerText = `Action failed. Make sure you registered a profile (Profile contract: ${profileAddr}).`;
        } catch (e) {
            document.getElementById("connectMessage").style.display = "block";
            document.getElementById("connectMessage").innerText = `Action failed: ${error.message || error}`;
        }
    }
}
async function $35da740d59af89ba$var$displayTweets(userAddress) {
    const tweetsContainer = document.getElementById("tweetsContainer");
    tweetsContainer.innerHTML = "";
    const tempTweets = await $35da740d59af89ba$var$contract.methods.getAllTweets(userAddress).call();
    const tweets = [
        ...tempTweets
    ];
    tweets.sort((a, b)=>b.timestamp - a.timestamp);
    for(let i = 0; i < tweets.length; i++){
        const tweetElement = document.createElement("div");
        tweetElement.className = "tweet";
        const userIcon = document.createElement("img");
        userIcon.className = "user-icon";
        userIcon.src = `https://avatars.dicebear.com/api/human/${tweets[i].author}.svg`;
        userIcon.alt = "User Icon";
        tweetElement.appendChild(userIcon);
        const tweetInner = document.createElement("div");
        tweetInner.className = "tweet-inner";
        tweetInner.innerHTML += `
        <div class="author">${$35da740d59af89ba$var$shortAddress(tweets[i].author)}</div>
        <div class="content">${tweets[i].content}</div>
    `;
        const likeButton = document.createElement("button");
        likeButton.className = "like-button";
        likeButton.innerHTML = `
        <i class="far fa-heart"></i>
        <span class="likes-count">${tweets[i].likes}</span>
    `;
        likeButton.setAttribute("data-id", tweets[i].id);
        likeButton.setAttribute("data-author", tweets[i].author);
        $35da740d59af89ba$var$addLikeButtonListener(likeButton, userAddress, tweets[i].id, tweets[i].author);
        tweetInner.appendChild(likeButton);
        tweetElement.appendChild(tweetInner);
        tweetsContainer.appendChild(tweetElement);
    }
}
function $35da740d59af89ba$var$addLikeButtonListener(likeButton, address, id, author) {
    likeButton.addEventListener("click", async (e)=>{
        e.preventDefault();
        const orig = likeButton.innerHTML;
        likeButton.innerHTML = '<div class="spinner"></div>';
        likeButton.disabled = true;
        try {
            await $35da740d59af89ba$var$likeTweet(author, id);
            await $35da740d59af89ba$var$displayTweets(address);
        } catch (error) {
            console.error("Error liking tweet:", error);
        } finally{
            likeButton.disabled = false;
            likeButton.innerHTML = orig;
        }
    });
}
function $35da740d59af89ba$var$shortAddress(address, startLength = 6, endLength = 4) {
    return `${address.slice(0, startLength)}...${address.slice(-endLength)}`;
}
async function $35da740d59af89ba$var$likeTweet(author, id) {
    try {
        const accounts = await $35da740d59af89ba$var$web3.eth.getAccounts();
        await $35da740d59af89ba$var$contract.methods.likeTweet(author, id).send({
            from: accounts[0]
        });
    } catch (error) {
        console.error("User rejected request:", error);
        throw error;
    }
}
function $35da740d59af89ba$var$setConnected(address) {
    document.getElementById("userAddress").innerText = "Connected: " + $35da740d59af89ba$var$shortAddress(address);
    document.getElementById("connectMessage").style.display = "none";
    document.getElementById("tweetForm").style.display = "block";
    $35da740d59af89ba$var$displayTweets(address);
}
document.getElementById("connectWalletBtn").addEventListener("click", $35da740d59af89ba$var$connectWallet);
document.getElementById("tweetForm").addEventListener("submit", async (e)=>{
    e.preventDefault();
    const content = document.getElementById("tweetContent").value;
    const tweetSubmitButton = document.getElementById("tweetSubmitBtn");
    const orig = tweetSubmitButton.innerHTML;
    tweetSubmitButton.innerHTML = '<div class="spinner"></div>';
    tweetSubmitButton.disabled = true;
    try {
        await $35da740d59af89ba$var$createTweet(content);
    } catch (error) {
        console.error("Error sending tweet:", error);
    } finally{
        tweetSubmitButton.innerHTML = orig;
        tweetSubmitButton.disabled = false;
    }
});


//# sourceMappingURL=repo.ee6e5a93.js.map
